import { SignInFormConfig } from '../../models/sign-in-form/sign-in-form-config.interface';
import { mockCmsSignInForm } from '../cms/cms-sign-in-form.mock';
import { mockSignInFormValue } from './sign-in-form-value.mock';

export const mockSignInFormConfig: SignInFormConfig = {
  cmsData: mockCmsSignInForm,
  initialValue: mockSignInFormValue,
};
